import { ReactNode } from "react";
import { FCX, sanitize, Tooltip } from "@datassential/platform-ui-lib";
import './PublicationCard.scss';
import TileSubTitle from "@components/ReportProTile/TileSubTitle";
import { iReportProPublication } from "@models/ReportProPublication";
import LazyImage from "@components/LazyImage/LazyImage";
import placeholderImg from "../../img/image-placeholder.png";
import cn from "classnames";

const PublicationCard: FCX<{
    data: iReportProPublication;
    index: number;
    link: string;
    tooltipId: string;
    testIdBase?: string;
    placeholder?: ReactNode;
}> = ({
    data,
    index,
    link,
    tooltipId,
    className,
    testIdBase = 'PublicationCard',
    placeholder,
}) => {
    return (
        <div
            className={cn("PublicationCard", className)}
            data-tooltip-id={tooltipId}
            data-testid={`button${testIdBase}-${index}`}
        >
            <LazyImage
                src={data.thumbnail}
                alt={data.title}
                className="PublicationCard__thumbnail"
                placeholder={placeholder ?? <img src={placeholderImg as string} alt="" />}
            />
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
                className="PublicationCard__link"
                target="_blank"
                rel="noreferrer"
                href={sanitize(link)}
                data-testid={`button${testIdBase}ExternalLink-${index}`}
            />
        </div>
    );
};

export const PublicationCardTooltip: FCX<{
    data: iReportProPublication;
    index: number;
    tooltipId: string;
    testIdBase?: string;
}> = ({
    data,
    index,
    style,
    className,
    tooltipId,
    testId = 'blockPublicationCardTooltip',
    testIdBase = 'PublicationCard',
}) => {
    return (
        <Tooltip
            className={cn("PublicationCardTooltip", className)}
            style={style}
            testId={testId}
            id={tooltipId}
            place="top"
        >
            <div className="PublicationCardTooltip__container">
                <div
                    className="PublicationCardTooltip__title"
                    data-testid={`text${testIdBase}Title-${index}`}
                >
                    {data.title}
                </div>
                <TileSubTitle
                    data={data}
                    testId={`text${testIdBase}SubTitle-${index}`}
                />
                <div
                    className="PublicationCardTooltip__description"
                    data-testid={`text${testIdBase}Description-${index}`}
                >
                    {data.description}
                </div>
            </div>
        </Tooltip>
    );
};

export default PublicationCard;
